import { create } from "zustand";

interface MissionControlState {
  selectedProjectId: string | null;
  selectedProject: any | null;
  isLoading: boolean;
  setSelectedProject: (projectId: string | null, project?: any) => void;
  clearSelectedProject: () => void;
  setLoading: (loading: boolean) => void;
}

export const useMissionControlStore = create<MissionControlState>((set) => ({
  selectedProjectId: null,
  selectedProject: null,
  isLoading: false,
  setSelectedProject: (projectId, project) =>
    set({ selectedProjectId: projectId, selectedProject: project }),
  clearSelectedProject: () =>
    set({ selectedProjectId: null, selectedProject: null }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
